//(function () {
//	'use strict';

//    const module = angular.module('imApp');

//    module.component('batchDeliveryAdd', {
//        templateUrl: 'views/components/views/batchDeliveryAdd/batchDeliveryAdd.template.html?v=' + module.version,
//		controllerAs: 'vm',
//        controller: ['$stateParams', 'batchDeliveryAddService', function ($stateParams, batchDeliveryAddService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let batchDeliveryKeyno = $stateParams.batchdelivery_keyno;

//            vm.model = {
//                bgBatchDeliveryAddSelection: {
//                    selected: 'all',
//                    buttons: [
//                        { id: 'all', label: 'batchdelivery_receive_all', color: 'primary', onClick: () => vm.model.bgBatchDeliveryAddSelection.selected = 'all' },
//                        { id: 'to_date', label: 'batchdelivery_receive_to_date', color: 'primary', onClick: () => vm.model.bgBatchDeliveryAddSelection.selected = 'to_date' }
//                    ]
//                },
//                itemsListSelectSuppliers: []
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function retrieveSuppliers() {
//                vm.model.itemsListSelectSuppliers = await batchDeliveryAddService.listBatchDeliverySelectSuppliers({
//                    batchdelivery_keyno: batchDeliveryKeyno,
//                    period_selector: vm.model.bgBatchDeliveryAddSelection.selected
//                });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON RADIO FUNCTIONS

//            vm.selectBgBatchDeliveryAddSelection = function (value) {
//                vm.model.bgBatchDeliveryAddSelection.selected = value;
//                retrieveSuppliers();
//            }

//            // #endregion BUTTON RADIO FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = async function () {
//                retrieveSuppliers();
//            }

//            // #endregion ON INIT FUNCTION

//		}]
//	});
//})();
